import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

export interface IconCountItem {
  key: string | number;
  label: string;
  count: number;
  icon?: string;
  iconClass?: string;
  iconBgClass?: string;
  avatarText?: string;
  avatarClass?: string;
  countBadgeClass?: string;
  routerLink?: any;
  queryParams?: any;
}

@Component({
  selector: 'app-icon-count-list',
  standalone: true,
  imports: [NgClass, RouterLink, MatIconModule],
  template: `
    <div class="flex flex-col gap-1">
      @for (item of items; track item.key) {
        <a
          [routerLink]="item.routerLink ?? null"
          [queryParams]="item.queryParams"
          class="flex items-center gap-2.5 rounded-lg border border-gray-100 bg-white px-2.5 py-1.5 shadow-sm transition-colors"
          [class.hover:bg-gray-50]="item.routerLink"
          [class.cursor-default]="!item.routerLink"
        >
          @if (item.avatarText) {
            <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[10px] font-bold" [ngClass]="item.avatarClass ?? 'bg-primary/10 text-primary'">
              {{ item.avatarText }}
            </div>
          } @else {
            <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md" [ngClass]="item.iconBgClass ?? 'bg-gray-100'">
              <mat-icon class="!text-sm !leading-none" [ngClass]="item.iconClass ?? 'text-gray-500'">{{ item.icon ?? 'label' }}</mat-icon>
            </div>
          }
          <span class="min-w-0 flex-1 truncate text-xs font-semibold text-gray-700">{{ item.label }}</span>
          <span class="shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold" [ngClass]="item.countBadgeClass ?? 'bg-gray-100 text-gray-600'">{{ item.count }}</span>
        </a>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCountListComponent {
  @Input() items: IconCountItem[] = [];
}
